module.exports = __webpack_public_path__ + "static/media/Portrait-10201.16bf7f6e.jpg";